import { useMutation } from '@tanstack/react-query'
import { handlePatchRequest } from '../utils/api-handler.util'
import { QueryKeys } from '../utils/queryKeyGenerator'
import { showToaster } from '../utils/show-toaster.util'
import USER_TYPE from '../constants/userType'
import { useParams } from 'react-router-dom'

export const useDocumentReview = (shopId, userType) => {
  const { id } = useParams()
  const reviewDocumentMutation = useMutation({
    mutationFn: async ({ id, approve, rejectReason }) => {
      const payload = {
        id,
        approve,
        ...(rejectReason && { rejectReason }),
      }

      return handlePatchRequest('/admin/shop-documents/review', payload)
    },
    onSuccess: (data, variables) => {
      const action = variables.approve ? 'approved' : 'rejected'
      showToaster(`Document ${action} successfully`, 'success')

      if (userType === USER_TYPE.retailer) {
        QueryKeys.adminRetailerDetails.invalidate(shopId)
      } else if (userType === USER_TYPE.wholeseller) {
        QueryKeys.adminWholesellerDetails.invalidate(shopId)
      }
      QueryKeys.adminShopVerificationDetails.invalidate(id)
    },
    onError: (error) => {
      console.error('Document review error:', error)
      showToaster(error.response?.data?.message || 'Failed to process document review', 'error')
    },
  })

  const approveDocument = (documentId) => {
    return reviewDocumentMutation.mutateAsync({
      id: documentId,
      approve: true,
    })
  }

  const rejectDocument = (documentId, rejectReason) => {
    return reviewDocumentMutation.mutateAsync({
      id: documentId,
      approve: false,
      rejectReason,
    })
  }

  return {
    approveDocument,
    rejectDocument,
    isLoading: reviewDocumentMutation.isPending,
    error: reviewDocumentMutation.error,
  }
}
